import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';
import { getNextQuarterDates } from 'scaleflow/utils/next-quarter-dates';

export function copyExistingScenarioToNewScenario(existing_scenario) {
  let new_scenario = this.store.createRecord('investment-scenario');
  new_scenario = existing_scenario.copy_to_object(new_scenario);
  return new_scenario;
}

class RoadmapStrategyCreateRoute extends Route {
  @service store;
  defaultStatus = [
    'ACTIVE',
    'READY',
    'READY FOR PLANNING',
    'DISCOVERY',
    'DRAFT',
  ];

  queryParams = {
    status: {
      refreshModel: false,
    },
    from: {
      refreshModel: false,
    },
    to: {
      refreshModel: false,
    },
    sources: {
      refreshModel: false,
    },
    product_managers: {
      refreshModel: false,
    },
    themes: {
      refreshModel: false,
    },
    teams: {
      refreshModel: false,
    },
  };

  scenarios = [];

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.set('initiatives', model.initiatives);
  }

  async model(params) {
    const _params = { ...params };
    delete _params['grouping'];
    if (_params.status == undefined || _params.status.length === 0)
      _params.status = this.defaultStatus;
    const scenarios = await this.store.findAll('investment-scenario', {
      reload: true,
    });
    const scenario = copyExistingScenarioToNewScenario.call(
      this,
      scenarios?.[0],
    );

    // Initialize roadmap with default dates
    const { start: quarter_start_date, end: quarter_end_date } =
      getNextQuarterDates();
    const roadmap = this.store.createRecord('roadmap', {
      start_date: quarter_start_date,
      end_date: quarter_end_date,
      'investment-scenario': scenario,
    });

    return RSVP.hash({
      initiatives: this.store
        .query('initiative', _params)
        .then(async (results) => {
          const initiatives = results.slice();
          const promises = [];
          initiatives.forEach((initiative) => {
            promises.push(initiative.belongsTo('bon').load());
            promises.push(initiative.hasMany('initiative-updates').load());
          });
          await Promise.all(promises);
          return results;
        }),
      scenarios,
      roadmap: roadmap,
      scenario: scenario,
    });
  }
}

export default instrumentRoutePerformance(RoadmapStrategyCreateRoute);
